import React from 'react';
import './AgentBadge.css';

export const AgentBadge: React.FC<{ count?: number }> = ({ count = 0 }) => count > 0 ?
  <span className="agent-badge" role="img" aria-label={`${count} Agent${count === 1 ? '' : 's'}`} title={`${count} Bureau Agents`}>
    <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 2 21 7 28 9 27 19 22 26 16 30 10 26 5 19 4 9 11 7Z" fill="#d6bb78" stroke="#342f25" /><circle cx="16" cy="12" r="4" fill="#253c40"/><path d="M9 23v-3q7-7 14 0v3Z" fill="#253c40"/></svg>
    <strong>{count}</strong>
  </span> : <div />;
